import React from 'react';
import styled from 'styled-components';
import Frame from './frame';

const Container = styled.div`
  width: 100%;
  display: flex;
`;

const FrameWithSubject = ({ subject, ...props }) => {
  return (
    <Container>
      <Frame {...props} subjectToggled={subject ? true : false} />
      {subject}
    </Container>
  );
};

export default FrameWithSubject;
